import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Loaderspinner from "../Loader";
import { getResourceUsers, deleteResourceUser, showToast } from "../../Pages/Utils/utils";
import { Row, Col } from "react-bootstrap";
import ReactPaginate from "react-paginate";
import { Link } from "react-router-dom";
import SweetAlert from "react-bootstrap-sweetalert";

const UserList = ({ id }) => {
    const navigate = useNavigate()
    const [loading, setLoading] = useState(false)
    const [page, setPage] = useState(0);
    const [totalPages, setTotalPages] = useState(1);
    const [search, setSearch] = useState("");
    const [userList, setUsersList] = useState([]);
    const [userid, setUserId] = useState(null);
    const [showAlert, setShowAlert] = useState(false);

    useEffect(() => {
        if (search.length == 0 || search.length >= 3) {
            fetchList();
        }
    }, [page, search]);

    const fetchList = async () => {
        try {
            setLoading(true);
            const limit = 10;
            const offset = page * limit;

            const response = await getResourceUsers({ resource_id: id, search, limit, offset });

            if (response?.status == 200) {
                setUsersList(response?.data?.rows);
                if ((response?.data?.count || 0) < limit) {
                    setTotalPages(page + 1);
                } else {
                    setTotalPages(page + 2);
                }
            } else {
                console.log("cannot fetch resources", response)
            }

        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false);
        }
    };

    const openAnalytics = (referenceId, type, event) => {
        const breadcrumbs = [
            { label: "Manage Resource", path: `/manage-resource/${id}` },
            { label: "Agents", path: `/manage-resource/${id}` }
        ];
        navigate("/analytics-detail", {
            state: {
                reference_id: referenceId,
                type,
                event,
                breadcrumbs
            }
        });
    };

    const handleDelete = async () => {
        var res = await deleteResourceUser(userid)
        if (res.status == 200) {
            showToast("Deleted successfully", "success");
            fetchList();
        }
        setShowAlert(false);
    };


    return (
        <>
            {loading && <Loaderspinner />}
            <div className="">
                <div className="d-flex align-items-center justify-content-end mb-3">
                    <input
                        type="text"
                        className="search-input mx-2"
                        placeholder="Search"
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                    />
                    <Link to={`/create-user/${id}`}>
                        <button className="export-btn"> Create Agent </button>
                    </Link>
                </div>
                <div className="row">
                    <div className="col">
                        <div className="table-responsive">
                            <table className="table align-items-center table-flush">
                                <thead className="thead-light">
                                    <tr>
                                        <th>Name</th>
                                        <th>Email</th>
                                        <th>Description</th>
                                        <th>Website</th>
                                        <th>Visits</th>
                                        <th>Connect</th>
                                        <th>Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {userList?.length > 0 ? (
                                        userList.map((user, index) => (
                                            <tr key={index}>
                                                <td>{user?.name}</td>
                                                <td>{user?.email || '-'}</td>
                                                <td style={{ maxWidth: "300px" }}>
                                                    <span className="truncate-text" style={{ whiteSpace: "pre-wrap" }}>
                                                        {user?.description}
                                                    </span>
                                                </td>
                                                <td>{user?.website}</td>
                                                <td>
                                                    <button className="viewproject-btn pull-right" style={{ width: "fit-content" }} onClick={() => openAnalytics(user?.id, "resource_user", "visit_site")}>
                                                        {user?.visit_count || 0}
                                                    </button>
                                                </td>
                                                <td>
                                                    <button className="viewproject-btn pull-right" style={{ width: "fit-content" }} onClick={() => openAnalytics(user?.id, "resource_user", "connect")}>
                                                        {user?.connect_count || 0}
                                                    </button>
                                                </td>
                                                <td style={{ width: "140px" }}>
                                                    <Link to={`/resources/${id}/edit-user/${user?.id}`}>
                                                        <button className="viewproject-btn pull-right mb-1" >
                                                            <span className="text-white">Edit</span>
                                                        </button>
                                                    </Link>
                                                    <Link to={`/create-user-video/${user?.id}`}>
                                                        <button className="viewproject-btn pull-right mb-1" onClick={() => {
                                                            setUserId(user?.id)
                                                        }}>
                                                            <span className="text-white">Manage Video</span>
                                                        </button>
                                                    </Link>
                                                    <Link to={`/manage-user/${id}/button/${user?.id}`}>
                                                        <button className="viewproject-btn pull-right mb-1" onClick={() => {
                                                            setUserId(user?.id)
                                                        }}>
                                                            <span className="text-white">Manage Buttons</span>
                                                        </button>
                                                    </Link>
                                                    <button className="viewproject-btn pull-right mb-1" onClick={() => {
                                                        setUserId(user?.id)
                                                        setShowAlert(true)
                                                    }} >
                                                        <span className="text-white">Delete</span>
                                                    </button>
                                                </td>
                                            </tr>
                                        ))) :
                                        <tr>
                                            <td colSpan="10" className="text-center"><b>No records found</b></td>
                                        </tr>
                                    }
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>

                <Row>
                    <Col xs={12}>
                        <div className='paginate-css'>
                            <ReactPaginate
                                previousLabel="<"
                                nextLabel=">"
                                breakLabel="..."
                                pageCount={totalPages}
                                marginPagesDisplayed={1}
                                pageRangeDisplayed={2}
                                onPageChange={({ selected }) => setPage(selected)}
                                containerClassName="pagination"
                                activeClassName="active"
                            />
                        </div>
                    </Col>
                </Row>
            </div >
            {
                showAlert && (
                    <SweetAlert
                        warning
                        showCancel
                        confirmBtnText="Yes, delete it!"
                        confirmBtnBsStyle="danger"
                        cancelBtnBsStyle="secondary"
                        title="Are you sure?"
                        onConfirm={handleDelete}
                        onCancel={() => setShowAlert(false)}
                        focusCancelBtn
                    >
                        This action cannot be undone.
                    </SweetAlert>
                )
            }
        </>
    );
};

export default UserList;
